export default __webpack_public_path__ + "static/HelveticaNeue-58ad5f7593b22013832463c91268f0fe.woff";